import { StaticField, Popup, Button, Box } from "@intech/web-ui";
import React, { useState } from "react";
import { PrestacaoEntidade } from "../../../../entidades";
import { PrestacaoModalConteudo } from "./PrestacaoModalConteudo";

interface ItemProps {
  prestacoes: Array<PrestacaoEntidade>;
}

export const Prestacoes: React.FC<ItemProps> = ({ prestacoes }) => {
  const [popupBody, setPopupBody] = useState(false);
  const [title, setTitle] = useState("");
  const [prestacao, setPrestacao] = useState<PrestacaoEntidade>(new PrestacaoEntidade());

  function ToMoney(Valor: number | undefined) {
    if (Valor == undefined) {
      return "0";
    }
    return "R$ " + Valor.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function openPopup(title: string, prestacao: PrestacaoEntidade) {
    setTitle(title);
    setPrestacao(prestacao);
    setPopupBody(true);
  }

  const itens = prestacoes.map((prestacao: PrestacaoEntidade, index: number) => {
    return (
      <tr key={index}>
        <td>{prestacao.PARCELA}</td>
        <td>{prestacao.DT_VENC}</td>
        <td>{prestacao.DT_PAGTO}</td>
        <td>
          <Button
            onClick={() => openPopup(`Prestação de Vencimento ${prestacao.DT_VENC}`, prestacao)}
            title={ToMoney(prestacao.VL_PRESTACAO!)}
            type={"primary"}
          />
        </td>
        <td>
          <StaticField value={prestacao.VL_RECEBIDO!} type={"money"} />
        </td>
        <td>
          <StaticField value={prestacao.VL_SALDO_ATUAL!} type={"money"} />
        </td>
      </tr>
    );
  });

  return (
    <Box title={"Prestações"}>
      <div className={"table-responsive"}>
        <table className={"table table-striped table-sm"}>
          <thead>
            <tr>
              <th>Nº</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Prestação</th>
              <th>Recebido</th>
              <th>Saldo Devedor</th>
            </tr>
          </thead>
          <tbody>{itens}</tbody>
        </table>
      </div>

      <Popup type={"body"} title={title} visible={popupBody} onClose={() => setPopupBody(false)} closeButtonTitle={"OK, Entendi!"}>
        <PrestacaoModalConteudo prestacao={prestacao} />
      </Popup>
    </Box>
  );
};
